var _defs, _clipPath, _path, _circle, _path2, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderBrasil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 742,
    width: 1060,
    viewBox: "-2100 -1470 6183.333 4328.333",
    id: "svg2008",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "gcut"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -31.5,0 v -70 h 63 V 0 Z M 0,-47 v 12 h 31.5 v -12 z",
    id: "path1889"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    clipPath: "url(#gcut)",
    id: "use1892",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1894",
    d: "M5-35H31.5V-25H5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1896",
    d: "M21.5-35H31.5V0H21.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    id: "use1902",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28,0 c 0,-10 0,-32 -15,-32 H -6 c 22,0 22,22 22,32",
    id: "path1904"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)",
    id: "use1909",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)",
    id: "use1912",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(-72)",
    id: "use1914",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)",
    id: "use1916",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(-144)",
    id: "use1918",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "scale(31.5)",
    id: "use1921",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "scale(26.25)",
    id: "use1924",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "scale(21)",
    id: "use1927",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "scale(15)",
    id: "use1930",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "scale(10.5)",
    id: "use1933",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "D",
    fillRule: "evenodd",
    d: "m -31.5,0 h 33 a 30,30 0 0 0 30,-30 v -10 a 30,30 0 0 0 -30,-30 h -33 z m 13,-13 h 19 a 19,19 0 0 0 19,-19 v -6 a 19,19 0 0 0 -19,-19 h -19 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    transform: "translate(-31.5)",
    d: "M 0,0 H 63 V -13 H 12 V -31 H 52 V -43 H 12 V -57 H 60 V -70 H 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m -26.25,0 h 52.5 v -12 h -40.5 v -16 h 33 v -12 h -33 V -51 H 25 v -12 h -51.25 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "m -31.5,0 h 12 v -48 l 14,48 h 11 l 14,-48 V 0 h 12 V -70 H 14 L 0,-22 -14,-70 h -17.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    fillRule: "evenodd",
    d: "M 0,0 A 31.5,35 0 0 0 0,-70 31.5,35 0 0 0 0,0 m 0,-13 a 18.5,22 0 0 0 0,-44 18.5,22 0 0 0 0,44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    fillRule: "evenodd",
    d: "m -31.5,0 h 13 v -26 h 28 a 22,22 0 0 0 0,-44 h -40 z m 13,-39 h 27 a 9,9 0 0 0 0,-18 h -27 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "m -15.75,-22 c 0,7 6.75,10.5 16.75,10.5 10,0 14.74,-3.25 14.75,-7.75 C 15.75,-33.5 -31,-24.5 -30.75,-49.5 -30.5,-71 -6,-70 3,-70 c 9,0 26,4 25.75,21.25 H 13.5 c 0,-7.5 -7,-10.25 -15,-10.25 -7.75,0 -13.25,1.25 -13.25,8.5 -0.25,11.75 46.25,4 46.25,28.75 C 31.5,-3.5 13.5,0 0,0 -11.5,0 -31.55,-4.5 -31.5,-22 Z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "band"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 735,
    id: "circle1944",
    cx: 0,
    cy: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2461",
    transform: "matrix(1.4722222,0,0,1.4722222,991.66662,694.1667)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009b3a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 13.3475,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect2216",
    d: "M-2100-1470H2100V1470H-2100z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M -1743,0 0,1113 1743,0 0,-1113 Z",
    fill: "#fedf00",
    id: "path1940"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 735,
    fill: "#002776",
    id: "circle1942",
    cx: 0,
    cy: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m -2205,1470 a 1785,1785 0 0 1 3570,0 h -105 a 1680,1680 0 1 0 -3360,0 z",
    clipPath: "url(#band)",
    id: "path1947"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420,1470)",
    fill: "#009b3a",
    id: "g1979"
  }, /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(-7)",
    id: "use1949",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(-4)",
    id: "use1951",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#D",
    transform: "rotate(-1)",
    id: "use1953",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#E",
    transform: "rotate(2)",
    id: "use1955",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#M",
    transform: "rotate(5)",
    id: "use1957",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#e",
    transform: "rotate(9.75)",
    id: "use1959",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#P",
    transform: "rotate(14.5)",
    id: "use1961",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(17.5)",
    id: "use1963",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(20.5)",
    id: "use1965",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#G",
    transform: "rotate(23.5)",
    id: "use1967",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(26.5)",
    id: "use1969",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#E",
    transform: "rotate(29.5)",
    id: "use1971",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#S",
    transform: "rotate(32.5)",
    id: "use1973",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#S",
    transform: "rotate(35.5)",
    id: "use1975",
    x: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(38.5)",
    id: "use1977",
    x: 0,
    width: "100%",
    height: "100%"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMi",
    y: -132,
    x: -600,
    xlinkHref: "#star1",
    width: "100%",
    height: "100%"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMa",
    y: 177,
    x: -535,
    xlinkHref: "#star1",
    width: "100%",
    height: "100%"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2CMa",
    y: 243,
    x: -625,
    xlinkHref: "#star2",
    width: "100%",
    height: "100%"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3CMa",
    y: 132,
    x: -463,
    xlinkHref: "#star4",
    width: "100%",
    height: "100%"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4CMa",
    y: 250,
    x: -382,
    xlinkHref: "#star2",
    width: "100%",
    height: "100%"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5CMa",
    y: 323,
    x: -404,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Vir",
    y: -228,
    x: 228,
    xlinkHref: "#star1",
    width: "100%",
    height: "100%"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Sco",
    y: 258,
    x: 515,
    xlinkHref: "#star1",
    width: "100%",
    height: "100%"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Sco",
    y: 265,
    x: 617,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Sco",
    y: 323,
    x: 545,
    xlinkHref: "#star2",
    width: "100%",
    height: "100%"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B8Sco",
    y: 477,
    x: 368,
    xlinkHref: "#star2",
    width: "100%",
    height: "100%"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B9Sco",
    y: 551,
    x: 367,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BASco",
    y: 419,
    x: 441,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BBSco",
    y: 382,
    x: 500,
    xlinkHref: "#star2",
    width: "100%",
    height: "100%"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BCSco",
    y: 405,
    x: 365,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Hya",
    y: 30,
    x: -280,
    xlinkHref: "#star2",
    width: "100%",
    height: "100%"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Hya",
    y: -37,
    x: 200,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Cru",
    y: 330,
    xlinkHref: "#star1",
    x: 0,
    width: "100%",
    height: "100%"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Cru",
    y: 184,
    x: 85,
    xlinkHref: "#star2",
    width: "100%",
    height: "100%"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Cru",
    y: 118,
    xlinkHref: "#star2",
    x: 0,
    width: "100%",
    height: "100%"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4Cru",
    y: 184,
    x: -74,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Cru",
    y: 235,
    x: -37,
    xlinkHref: "#star4",
    width: "100%",
    height: "100%"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1TrA",
    y: 495,
    x: 220,
    xlinkHref: "#star2",
    width: "100%",
    height: "100%"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2TrA",
    y: 430,
    x: 283,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3TrA",
    y: 412,
    x: 162,
    xlinkHref: "#star3",
    width: "100%",
    height: "100%"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Car",
    y: 390,
    x: -295,
    xlinkHref: "#star1",
    width: "100%",
    height: "100%"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03C3Oct",
    y: 575,
    xlinkHref: "#star5",
    x: 0,
    width: "100%",
    height: "100%"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBrasil);
export default __webpack_public_path__ + "static/media/header-brasil.91c36dfc079a40a7799e5ce4126a253c.svg";
export { ForwardRef as ReactComponent };